import { useCallback, useEffect, useRef, useState } from "react"

// Failed route request for the Result step. The toast is dismissable on its
// own; the error itself lives until the next run or until the inputs change.
export default function useRouteError({ inputsKey }) {
  const [routeError, setRouteErrorState] = useState(null)
  const [toastOpen, setToastOpen] = useState(false)

  const setRouteError = useCallback((error) => {
    setRouteErrorState(error)
    setToastOpen(!!error)
  }, [])

  const clearRouteError = useCallback(() => setRouteError(null), [setRouteError])

  const closeToast = useCallback((event, reason) => {
    if (reason === "clickaway") return
    setToastOpen(false)
  }, [])

  const lastKeyRef = useRef(inputsKey)
  useEffect(() => {
    if (lastKeyRef.current === inputsKey) return
    lastKeyRef.current = inputsKey
    clearRouteError()
  }, [inputsKey, clearRouteError])

  return { routeError, setRouteError, clearRouteError, toastOpen, closeToast }
}
